import React from "react";
import { connect } from 'react-redux';
import {Stepper,Step,StepLabel,Button,Typography,Snackbar} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import {Link} from 'react-router-dom'
import {createNewAvtal,getKundKontakter } from 'actions';
import KundInput from "./KundInput";
import KontaktPerson from "./KontaktPerson";
import { isUndefined,isEmpty } from 'lodash'
import Övrigt from "./Övrigt";
import Sammanfattning from "./Sammanfattning";
import { Redirect } from 'react-router-dom'
import moment from 'moment';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,Avtal,accountsData}) {
    const { authUser} = auth;
    const { isLoading,message,currentAvtal } = Avtal;
    const { KontakterList,KundSearch } = accountsData;
    return {
        isLoading,message,authUser,KontakterList,currentAvtal,KundSearch
    };
}
function mapDispatchToProps(dispatch) {
    return {
        createNewAvtal: (userid,AFid,Navtal) => dispatch(createNewAvtal(userid,AFid,Navtal)),
        getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
        dispatch
    };
}

function getSteps() {
    return ["Kund", "Kontaktperson", "Övrigt", "Sammanf."];
}
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class HorizontalLinearStepper extends React.Component {
    state = {
        activeStep: 0,
        message: "",
        showMessage: false,
        skipped: new Set(),
        KontakterList:[],
        newAvtal:{
            Kund:{},
            Kontakt:{},
            Avtal:{
                avtaltyp:0,
                Leverantor:"",
                Slutdatum:moment().format("YYYY-MM-DD HH:mm"),
                Omforhandle:moment().format("YYYY-MM-DD HH:mm"),
                StartDate:moment().format("YYYY-MM-DD HH:mm"),
                Varde:"",
                Rubrik:"",
                Laperut:0
            }
        }
    };
    handleRequestClose = () => {
        this.setState({
          showMessage: false,
          message: ''
        });
      };
    SetAvtalKParameters = (kontakt)=>{
        this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                kontakt:kontakt
            }
        })
    }
    SetAvtalParameters = (Avtal)=>{
       this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                Avtal:Avtal
            }
        })
    }
    SetAvtalKundParameters = (Kund)=>{
        this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                Kund:Kund
            }
        })
        if(!isUndefined(Kund.Orgnr) && Kund.Source===1){
            const userid = this.props.authUser.user_id;
            const Kontoid = this.props.authUser.user_Afid;
            this.props.getKundKontakter(userid,Kontoid,Kund.Orgnr)
        }
    }
    componentDidUpdate=()=>{
        if(this.state.KontakterList !== this.props.KontakterList){
            this.setState({
                KontakterList:this.props.KontakterList
            })
        }
        if(!isEmpty(this.props.currentAvtal)){
            const id = this.props.currentAvtal.Avtal.id
        }
    }
    getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <KundInput
                    Kund={this.state.newAvtal.Kund} 
                    KundSearch={this.props.KundSearch}               
                    SetAvtalKundParameters={this.SetAvtalKundParameters}                
                    />
                );
            case 1:{
                    
                return (
                    <KontaktPerson 
                    KundOrgnr={this.state.newAvtal.Kund.Orgnr}
                    kontakt={this.state.newAvtal.kontakt}
                    Kontakter={isEmpty(this.state.KontakterList)?[]:this.state.KontakterList}
                    isLoading={isEmpty(this.state.KontakterList)?true:false}
                    SetAvtalParameters={this.SetAvtalKParameters}
                    />
                    );
            }
                
            case 2:
                return (
                      <Övrigt 
                    newAvtal={this.state.newAvtal}
                    SetAvtalParameters={this.SetAvtalParameters}
                    />
                );
            case 3:
                return (
                    <Sammanfattning 
                    newAvtal={this.state.newAvtal}
                    step={step}
                    />
                );
            default:
                return "Unknown step";
        }
    }
    isStepOptional = step => {
        return step === 1;
    };
    handleNext = () => {
        const { activeStep } = this.state;
        let isDisabled = this.checkIfDisabled();
        if(isDisabled){}
        else{
        let { skipped } = this.state;
        if (this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
        }
        this.setState({
            activeStep: activeStep + 1,
            skipped
        });
        }
    };
    handleBack = () => {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep - 1
        });
    };
    handleSkip = () => {
        const { activeStep } = this.state;
        if (!this.isStepOptional(activeStep)) {
           throw new Error("You can't skip a step that isn't optional.");
        }
        const skipped = new Set(this.state.skipped.values());
        skipped.add(activeStep);
        this.setState({
            activeStep: this.state.activeStep + 1,
            skipped
        });
    };
    handleReset = () => {
        this.setState({
            activeStep: 0
        });
    };

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }
    saveNewAvtal=()=>{
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        const newAvtal =this.state.newAvtal;
        this.props.createNewAvtal(userid,Kontoid,newAvtal)  
        this.props.handleClose()
       // return <Redirect to={`/app/AvtalsKort`} />
    }
    checkIfDisabled=()=>{
        const activeStep = this.state.activeStep
        switch(activeStep){
            case 0:
                return (isEmpty(this.state.newAvtal.Kund))
            case 1:
                return (isUndefined(this.state.newAvtal.kontakt))
            case 2:
                return (parseInt(this.state.newAvtal.Avtal.avtaltyp)===0)
            default:
                return false
        }
    }
    render() {
        const steps = getSteps();
        const { activeStep,message,showMessage } = this.state;
        console.log(this.props.KundSearch)
        return (
            <div className="w-100">
                <Stepper activeStep={activeStep} className="horizontal-stepper-linear">
                    {steps.map((label, index) => {
                        const props = {};
                        const labelProps = {};
                        if (this.isStepSkipped(index)) {
                            props.completed = false;
                        }
                        return (
                            <Step
                                key={label}
                                className={`horizontal-stepper ${
                                    index === activeStep ? "active" : ""
                                    }`}
                                {...props}
                            >
                                <StepLabel className="stepperlabel" {...labelProps}>
                                    {label}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <div>
                    {activeStep === steps.length ? (
                        <div>
                            <Typography className="my-2">
                                Alla steg är klara!
                            </Typography>
                            <Button onClick={this.handleReset} className="jr-btn">
                                Börja om
                            </Button>
                        </div>
                    ) : (
                            <div>
                                <Typography className="my-2">
                                    {this.getStepContent(activeStep)}
                                </Typography>
                                <div className="d-flex">
                                    <div>
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={this.handleBack}
                                            className="jr-btn"
                                            variant="outlined"
                                            color="default"
                                        >
                                            <IntlMessages id="Stepper.Back"/>
                                    </Button>
                                    </div>
                                    <div className="ml-auto">
                                    {activeStep === steps.length - 1 ? 
                                    <Button
                                    color="primary"
                                    className="jr-btn"
                                    variant="contained"
                                    onClick={this.saveNewAvtal}
                                    >
                                        Skapa
                                    </Button>
: 
<Button
variant="contained"
color="primary"
onClick={this.handleNext}
className="jr-btn"
>
    {"Nästa"}
</Button>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
                <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        open={showMessage}
                        autoHideDuration={3000}
                        onClose={this.handleRequestClose}
                        ContentProps={{
                          "aria-describedby": "message-id"
                        }}>
                        <Alert onClose={this.handleRequestClose} 
                        severity={message === "Error"?"error":"success"}
                        ><span id="message-id">{message}</span></Alert>
                      </Snackbar>
            </div>
        );
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(HorizontalLinearStepper);
